
let homeActions = {
  getVideos: () => {
    const cb = Date.now()
    return fetch(`/config.json?cb=${cb}`)
      .then(function (response) {
        return response.json()
      })
  }
}

export default homeActions



// WEBPACK FOOTER //
// ./src/components/homeActions.js